import type { QueryClient } from "@tanstack/react-query";
import { orpc } from "@/utils/orpc";

/** CRM lists and details change often while someone works; keep them fresh. */
export const CRM_STALE_TIME = 30 * 1000;
/** Pickers (owners, settings) rarely change. */
export const CRM_PICKER_STALE_TIME = 5 * 60 * 1000;

/**
 * Invalidates every CRM data query after a write. A contact create touches
 * companies, a stage move touches reports and the dashboard card, a task
 * touches timelines — refreshing the whole CRM data set is cheap and never
 * leaves a stale view behind. The access flags are left alone.
 */
export const invalidateCrmData = async (
	queryClient: QueryClient,
): Promise<void> => {
	const crm = orpc.admin.crm;
	await Promise.all(
		[
			crm.organizations.key(),
			crm.contacts.key(),
			crm.opportunities.key(),
			crm.tasks.key(),
			crm.activities.key(),
			crm.consents.key(),
			crm.reports.key(),
			crm.dsr.key(),
			crm.settings.key(),
		].map((queryKey) => queryClient.invalidateQueries({ queryKey })),
	);
};
